import type { routes, SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { apiFetch } from 'utils/apiFetch'

export const isOverlappingEventErrorForCreate = (
  response:
    routes.IrrigationSchedulerEventsCreate.Response | routes.IrrigationSchedulerPulseEventsCreate.Response,
): response is SharedTypes.IrrigationScheduler.IRRIGATION_SCHEDULER_ERROR.OVERLAPPING_EVENT =>
  response === 'OVERLAPPING_EVENT'

export const fertigationEventOverlappedErrorForCreate = (
  response:
    routes.IrrigationSchedulerEventsCreate.Response | routes.IrrigationSchedulerPulseEventsCreate.Response,
): response is SharedTypes.IrrigationScheduler.IRRIGATION_SCHEDULER_ERROR.FERTIGATION_SCHEDULE_OVERLAP =>
  response === 'FERTIGATION_SCHEDULE_OVERLAP'

export const fertigationEventErrorForCreate = (
  response:
    routes.IrrigationSchedulerEventsCreate.Response | routes.IrrigationSchedulerPulseEventsCreate.Response,
): response is SharedTypes.IrrigationScheduler.IRRIGATION_SCHEDULER_ERROR.FERTIGATION_SCHEDULE_OUT_OF_RANGE =>
  response === 'FERTIGATION_SCHEDULE_OUT_OF_RANGE'

export const fertigationInjectorFlowRateUnknownErrorForCreate = (
  response:
    routes.IrrigationSchedulerEventsCreate.Response | routes.IrrigationSchedulerPulseEventsCreate.Response,
): response is SharedTypes.IrrigationScheduler.IRRIGATION_SCHEDULER_ERROR.FERTIGATION_INJECTOR_FLOW_RATE_UNKNOWN =>
  response === 'FERTIGATION_INJECTOR_FLOW_RATE_UNKNOWN'

export const irrigationSchedulerEventsCreate = async (
  request: routes.IrrigationSchedulerEventsCreate.Request,
) => {
  const response = await apiFetch({ url: '/irrigation-scheduler-events-create', body: request })

  return response
}

export const pulseIrrigationSchedulerEventsCreate = async (
  request: routes.IrrigationSchedulerPulseEventsCreate.Request,
) => {
  const response = await apiFetch({ url: '/irrigation-scheduler-pulse-events-create', body: request })

  return response
}
